export default "<div id=\"container\"  style=\"height: 90% !important; min-width: 310px\"></div>\n"